const cartoApiKey = process.env.VUE_APP_CARTO_API_KEY;

// A missing key is not an error: CARTO still answers 200 and burns an
// "API key required" watermark into the tiles. https://carto.com/basemaps/apikey
export const cartoLightSource = `https://{s}.basemaps.cartocdn.com/rastertiles/light_all/{z}/{x}/{y}{r}.png${
	cartoApiKey ? `?key=${cartoApiKey}` : ''
}`;

// Keeping this visible is what the free CARTO tier is granted in exchange for.
export const mapAttribution =
	'&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>';
